import { Box, Chip } from '@mui/material'
import type { ReactNode } from 'react'
import { ListView } from '@ds/components'
import { RequestsHeader } from '../RequestsHeader'
import { TableSkeleton } from './TableSkeleton'
import { TABLE_REQUESTS_STATE_STRINGS } from './strings'

const listSx = { pt: 4, px: 4, pb: 3, gap: 3 } as const

interface TableRequestsStateProps {
  isLoading: boolean
  isError: boolean
  hasData: boolean
  search: string
  onSearchChange: (search: string) => void
  hideClosed: boolean
  onHideClosedChange: (hideClosed: boolean) => void
  pagination: {
    pageIndex: number
    pageSize: number
  }
  columnsCount: number
  children?: ReactNode
}

export const TableRequestsState = ({
  isLoading,
  isError,
  hasData,
  search,
  onSearchChange,
  hideClosed,
  onHideClosedChange,
  pagination,
  columnsCount,
  children,
}: TableRequestsStateProps) => {
  // Error state
  if (isError) {
    return (
      <ListView
        sx={listSx}
        header={
          <RequestsHeader
            search={search}
            setSearch={onSearchChange}
            hideClosed={hideClosed}
            setHideClosed={onHideClosedChange}
          />
        }
      >
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Chip
            label={TABLE_REQUESTS_STATE_STRINGS.errorLoadingRequests}
            color="error"
            variant="outlined"
          />
        </Box>
      </ListView>
    )
  }

  // Loading state
  if (isLoading) {
    return (
      <ListView
        sx={listSx}
        header={
          <RequestsHeader
            search={search}
            setSearch={onSearchChange}
            hideClosed={hideClosed}
            setHideClosed={onHideClosedChange}
          />
        }
      >
        <TableSkeleton rowsCount={pagination.pageSize} columnsCount={columnsCount} />
      </ListView>
    )
  }

  return (
    <ListView
      sx={listSx}
      header={
        <RequestsHeader
          search={search}
          setSearch={onSearchChange}
          hideClosed={hideClosed}
          setHideClosed={onHideClosedChange}
        />
      }
    >
      {children}
      {!hasData && search && (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Chip
            label={TABLE_REQUESTS_STATE_STRINGS.noRequestsFound}
            color="info"
            variant="outlined"
          />
        </Box>
      )}
    </ListView>
  )
}
